module.exports = __webpack_public_path__ + "img/etiquetas.087d0046.svg";